/* eslint-disable */
import React, { useState, useEffect } from "react";
import { db } from "../../firebase-config";
// import { Link } from "react-router-dom";
import { ref, onValue } from "firebase/database";
import "./GenerateLinkPatient.css";
import ChatNot from '../../components/Chat/ChatNot'; 
import '../../components/Chat/ChatNot.css';
import { useUserAuth } from "../../context/UserAuthContext";//deepa css
import { Button } from "react-bootstrap";//deepa css
import { Link, useNavigate } from "react-router-dom";//depa css
import CryptoJS from "crypto-js"; //deepa hippa

// Encryption function
const encrypt = (data) => {
    return window.btoa(data);
};
// Decryption function
const decryptData = (encryptedData) => {
  const secretKey = process.env.REACT_APP_SECRET_KEY || "default_key"; // Use env variable or a default key //deepa: Secret key for decryption
  try {
      const bytes = CryptoJS.AES.decrypt(encryptedData, secretKey);
      const decryptedData = bytes.toString(CryptoJS.enc.Utf8);
      if (!decryptedData) {
          throw new Error("Decryption failed");
      }
      return decryptedData;
  } catch (error) {
      console.warn("Error decrypting data, returning original data:", error);
      return encryptedData; // Return original encrypted data if decryption fails
  }
};




const GenerateLinkPatient = () => {
    const [patients, setPatients] = useState([]);
    const [generatedLinks, setGeneratedLinks] = useState({});
    const [modalVisible, setModalVisible] = useState(false);
    const [selectedLink, setSelectedLink] = useState("");

    const adminName = localStorage.getItem("adminName");
    const { logOut } = useUserAuth();//deepa css
    const navigate = useNavigate();//deepa css


    useEffect(() => {
      const patientsRef = ref(db, `superadmin/admins/${adminName}/patients`);
      onValue(patientsRef, (snapshot) => {
        const data = snapshot.val();
        if (data) {
          const decryptedData = Object.keys(data).reduce((acc, id) => {
            acc[id] = {
              ...data[id],
              FullName: decryptData(data[id].FullName),
              Age: decryptData(data[id].Age),
              Gender: decryptData(data[id].Gender),
              // Add other fields as necessary
            };
            return acc;
          }, {});
          setPatients(decryptedData);

            const baseUrl = process.env.NODE_ENV === "development"
              ? "http://localhost:3000"
              : "https://health.easiofy.com";  // <-- Updated AWS URL
         
         


          const links = Object.keys(decryptedData).reduce((acc, id) => {
            acc[id] = `${baseUrl}/patient/${encrypt(adminName)}/${encrypt(id)}`;
            return acc;
          }, {});
          setGeneratedLinks(links);
        }
      });
    }, [adminName]);
    
    const handleShareClick = (id) => {
        setSelectedLink(generatedLinks[id]);
        setModalVisible(true);
    };

    const copyToClipboard = () => {
        navigator.clipboard.writeText(selectedLink);
        alert("Link copied to clipboard!");
        setModalVisible(false); // Close modal after copying
    };

    const shareViaWhatsApp = () => {
        const whatsappUrl = `https://wa.me/?text=${encodeURIComponent("Click this link to View your Data: " + selectedLink)}`;
        window.open(whatsappUrl, "_blank");
        setModalVisible(false); // Close modal after sharing
    };

    const handleLogout = async () => {
        try {
          await logOut();
          navigate("/");
        } catch (error) {
          console.log(error.message);
        }
      };

    return (
        <>
            <div className="container-fluid">
                <h2 className="text-center adminlist">List of Patients</h2>

       {/* deepa css */}          

                <Button 
  variant="primary" 
  onClick={handleLogout} 
  className="logout-button" 
  style={{ position: 'absolute', top: '10px', right: '10px' }}
>
  <i className="fas fa-power-off logout-icon"></i>
</Button>
                {/* deepa css */}
                <Link to="/Admin" className="homeadButton">
                    <span id="backText" className="backText">Back</span>
                    <i id="backIcon" className="fas fa-long-arrow-alt-left fa-lg fa-2x"></i>
                </Link>
                <div style={{ marginTop: "100px" }}>
                  {/* deepa css change new */}
                  
                    <table className="styled-table ListofPatientTechPanel">
                        <thead>
                            <tr>
                                <th className="th-head T-NO">No.</th>
                                <th className="th-head T-NAME">Name</th>
                                <th className="th-head T-ACTION">Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {patients && Object.keys(patients).map((id, index) => (
                                <tr key={index}>
                                    <th scope="row">{index + 1}</th>
                                    <td className="admin-name NAME-AdminGenerateLinkPatient ">{patients[id].FullName}</td>
                                    <td>
                                        <button className="btn btn-view" onClick={() => window.open(generatedLinks[id], '_blank')}>Open Link</button>
                                        {/* Share Link button */}
                                        <button className="btn btn-view" onClick={() => handleShareClick(id)}>
                                            Share Link
                                        </button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
                {modalVisible && (
  <div className="PatientViewData modal-background" onClick={() => setModalVisible(false)}>
    <div className="PatientViewData modal-content" onClick={(e) => e.stopPropagation()}>
      <div className="modal-header">
        <h2>Share Patient Link</h2>
        <span className="close-btn" onClick={() => setModalVisible(false)}>&times;</span>
      </div>
      <div className="modal-body">
        <p>Select how you'd like to share:</p>
        <button onClick={copyToClipboard} className="modal-button copy-link">
          <i className="fas fa-copy"></i> Copy Link
        </button>
        <button onClick={shareViaWhatsApp} className="modal-button whatsapp-share">
          <i className="fab fa-whatsapp"></i> WhatsApp
        </button>
      </div>
    </div>
  </div>
)}
            </div>
            <div>
        <ChatNot />
      </div>
  
        </>
    );
};

export default GenerateLinkPatient;